<template>
  <svg style="cursor: pointer !important;" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="10" fill="white"/>
<path d="M31.35 22.04C30.67 18.59 27.64 16 24 16C21.11 16 18.6 17.64 17.35 20.04C14.34 20.36 12 22.91 12 26C12 29.31 14.69 32 18 32H31C33.76 32 36 29.76 36 27C36 24.36 33.95 22.22 31.35 22.04ZM29 25L24 30L19 25H22V21H26V25H29Z" fill="#727CF5"/>
</svg>

</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
  opacity: 0.5;
  transition: all 0.2s ease;
  &:hover {
    opacity: 1;
  }
}
</style>